export default __webpack_public_path__ + "static/media/currency.68f5b380.svg";